<template>
    <div class="store">
        <div class="returnBtn" @click="returnToLogin"><i class="iconfont icon-return"></i>返回</div>
        <div class="logoBox">
            <div class="title">
                <img src="../../assets/login/logo.png" alt="">
            </div>
            <p>基于云计算SaaS模式</p>
            <p>收银、营销一体化服务平台</p>
        </div>
        <div class="storeListBox">
           <!--  <div class="back" @click="()=>{ $router.push({path:'/login'}) }">
                <i class="iconfont icon-return"></i>
                <span>返回</span>
            </div> -->
            <div class="title">请选择你的店铺</div>
            <div class="storeScrollBox">
                <ul class="storeList">
                    <li v-for="(item,idx) in storeList" :class="{active:curIndex==idx}" @mousemove="curIndex=idx" @click="enterSystem(item)">{{item.name}}</li>
                </ul>
            </div>
            <div class="add">
                <div class="addBtn"><i class="iconfont icon-icon02"  @click="()=>{ $router.push({path:'/addStore'}) }"></i><span  @click="()=>{ $router.push({path:'/addStore'}) }">添加店铺</span></div>
            </div>
        </div>
    </div> 
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    import echarts from 'echarts';
    export default{
    	data () {
    		return {
                storeList: [], // 店铺列表
                curIndex:0,//当前店铺索引
    		}
    	},
        methods: {
            // 进入后台管理系统
            enterSystem: function ( item ) {
                localStorage.setItem("storeId",item.id);
                sessionStorage.setItem("call",JSON.stringify(item.call));
                sessionStorage.setItem("storeName",JSON.stringify(item.name));
                sessionStorage.setItem("purchase",JSON.stringify(item.purchaseEnabled));
                sessionStorage.setItem("tabNames","[]");
                this.$http.post('authorize?storeId='+item.id, {}).then(()=>{
                    this.$router.push({path:'/sys/'+item.id});
                })
            },
            // 编辑店铺
            editStore: function ( storeId ) {
                this.$router.push({path:'./addStore/'+storeId});
            },
            // 返回登录
            returnToLogin: function () {
                localStorage.clear();
                this.$router.push({path:'/login'});
            }
        },
        created: function () {
           
            this.$http.get('/stores').then((res)=>{
                this.storeList = res.data;
                if ( !this.storeList || !this.storeList[0] ) {
                    this.$router.push({path:'/addStore/true'});
                }
            }).catch((err) => {
                
            })
        },
    }
</script>
<style lang="scss" scoped>
    @import '../../../static/css/common.scss';
	@import "store";
</style>



// WEBPACK FOOTER //
// store.vue?71e07267